<template>
  <nav :class="isZeborne ? 'zeborne-style' : ''">
    <div class="nav-container" :class="[mobileState ? 'open' : '', isZeborne ? 'zeborne' : 'mcp']" :style="{'top': menuTopPosition()}">
      <ul id="nav" class="nav-content" :class="overlay ? 'show-overlay' : '' ">
        <div class="megamenu-overlay"></div>

        <li
          v-for="(menu, key) in menuDatas"
          :key="key"
          :id="'icon-category-node-' + menu.entity_id"
          :class="[
            menu.css_class,
            menu.is_product_menu == '1' ? 'product-menu' : '',
            menu.is_service_menu == '1' ? 'service-menu' : '',
            'nav-' + (key + 1),
            menu.children_categories ? 'parent' : '',
            tabActive == menu.name ? 'show-menu': '',
          ]"
          class="level0 gtm-element"
          :data-link="'nav-' + (key + 1)"
          @mouseenter="toggleSubMenu(menu)"
          @mouseleave="toggleSubMenu()"
          :data-gtmtext="menu.name"
          :data-gtmlink="setUrl(menu)"
        >
          <template v-if="isObfuscate">
            <ObfuscateLink 
              v-if="menu.children_categories || menu.landing_page"
              :dataHref="setUrl(menu)"
              :className="'has-children level0'"
              @click.prevent="toggleSubMenuMobile(menu)"
            >
              <template v-slot:content>
                <span>{{ menu.name }}</span>
              </template>
            </ObfuscateLink>
            <ObfuscateLink 
              v-else
              :dataHref="
                menu.category_url_redirect_menu
                  ? formatUrl(menu.category_url_redirect_menu)
                  : menu.soon_category_url_redirect
                  ? formatUrl(menu.soon_category_url_redirect)
                  : formatUrl(menu.url_path)
              "
              :className="'level0'"
            >
              <template v-slot:content>
                <span>{{ menu.name }}</span>
              </template>
            </ObfuscateLink>
          </template>
          <template v-else>
            <a
              v-if="menu.children_categories || menu.landing_page"
              @click.prevent="toggleSubMenuMobile(menu)"
              :href="setUrl(menu)"
              class="has-children level0"
            >
              <span>{{ menu.name }}</span>
            </a>
  
            <a
              v-else
              :href="
                menu.category_url_redirect_menu
                  ? formatUrl(menu.category_url_redirect_menu)
                  : menu.soon_category_url_redirect
                  ? formatUrl(menu.soon_category_url_redirect)
                  : formatUrl(menu.url_path)
              "
              class="level0"
            >
              <span>{{ menu.name }}</span>
            </a>
          </template>

          <!-----------------------
                MEGAMENU
        ------------------------>
          <!-- MegaMenu-fullcms without childrens -->
          <div v-if="!menu.children_categories && menu.landing_page" class="submenu-fullcms">
            <span @click="displayMainMenuMobile" class="category-label-mobile">{{
              menu.name
            }}</span>
            <div :inner-html.prop="menu.landing_page"></div>
          </div>

          <!-- submenu CMS with children-->
          <sub-menu
            v-else-if="menu.children_categories && menu.name != 'Voitures'"
            :categories="menu.children_categories"
            :typeMenu="menu.is_product_menu == '1' ? 'subproduct-menu' : 'subservice-menu'"
            :menuName="menu.name"
            :baseUrl="baseUrl"
            :obfuscate="isObfuscate"
            @displayMainMenuMobile="displayMainMenuMobile"
          ></sub-menu>

          <!-- submenu cars -->
          <component
            :is="componentInstance"
            v-else-if="menu.children_categories && menu.name == 'Voitures'"
            :carsDatas="carsDatas"
            :menuName="menu.name"
            :baseUrl="baseUrl"
            @displayMainMenuMobile="displayMainMenuMobile"
          ></component>
        </li>

        

        <!-- Language Switch -->
        <li v-if="isZeborne && menuDatas.length > 0" class="languageWidget level0">
          <SelectLanguageWidget />
        </li>

        <!-----------------------
                MOBILE ZEBORNE
        ------------------------>
        <div v-if="isZeborne" class="mobileOnly">
          <!-- contact -->
          <div class="menu-contact">
            <div class="menu-contact_content">
              <a v-if="phoneNumber" :href="'tel:' + phoneNumber" class="menu-contact__phone">
                <i class="icon icon-phone"></i>

                <div class="block-text">
                  <span class="phone-num" :inner-html.prop="phoneNumber"></span>
                  <span class="phone-info">Prix d'un appel local</span>
                </div>
              </a>

              <div class="menu-contact_calendar">
                <span>Lun-Ven</span>
                <span>8h00-18h30</span>
              </div>
            </div>

            <a :href="baseUrl + '/contacts/'" class="menu-contact_mail">Nous contacter par email</a>
          </div>

          <div class="menu-footer">
            <div title="ZEborne" class="logo">
              <img
                :src="baseUrlMedia + '/skin/frontend/mib/default/images/logo.svg'"
                alt="ZEborne"
              />
            </div>
            <p>
              Des services spécialisés IRVE depuis 5 ans pour 37 000 particuliers , professionnels
              et réseaux (dont 12 000 en 2017). La garantie d’installations en conformité avec les
              normes du bâtiment et du constructeur.
            </p>

            <div class="reviews">
              <div class="logo">
                <img
                  :src="baseUrlMedia + '/skin/frontend/mib/default/images/verified-reviews.svg'"
                  alt="avis vérifiés"
                />
              </div>
              <div class="rating">
                <img
                  :src="baseUrlMedia + '/media/topheaderblock/default/rating.png'"
                  alt="rating"
                />
                <span>4.4/5</span>
              </div>
            </div>
          </div>

          <ul class="footer-links">
            <li><a :href="baseUrl + '/mentions-legales'">Mentions légales</a></li>
            <li><a :href="baseUrl + '/cgv'">CGV</a></li>
            <li><a href="#">Cookies</a></li>
          </ul>
        </div>
      </ul>
    </div>
  </nav>
</template>

<script>
import SubMenu from "@/includes/Header/SubMenu/SubMenu.vue";
import { mapGetters } from "vuex";
import SelectLanguageWidget from "@/includes/Header/zeborne/SelectLanguageWidget/SelectLanguageWidget.vue";
import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';

export default {
  name: "Menu",

  data() {
    return {
      tabActive: null,
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      overlay: false,
      windowWidth: window.innerWidth,
      headerDOM: document.querySelector('header.header'),
    };
  },

  components: {
    SubMenu,
    SelectLanguageWidget,
    ObfuscateLink
  },

  computed: {
    ...mapGetters({ isZeborne: "isZeborne" }),

    //dynamic and conditional imports SubMenuCars
    componentInstance() {
      const name = this.isZeborne ? "SubMenuCars" : null;
      return () => import("@/includes/Header/zeborne/SubMenuCars/SubMenuCars.vue");
    },
  },

  props: {
    mobileState: {
      type: Boolean,
      required: false,
    },
    menuDatas: {
      type: Object,
      required: true,
    },
    carsDatas: {
      type: Object,
      required: true,
    },
    phoneNumber: {
      type: String,
      required: false,
      default: "",
    },
    baseUrl: {
      type: String,
      required: false,
      default: process.env.VUE_APP_API_BASE_URL,
    },
    baseUrlMedia: {
      type: String,
      required: false,
      default: process.env.VUE_APP_API_BASE_URL,
    },
    isObfuscate: false,
  },

  methods: {
    toggleSubMenu(menu) {
      if (this.windowWidth > 768) {
        if ((menu && menu.children_categories) || (menu && menu.landing_page)) {
          this.overlay = true;
          this.tabActive = menu.name;
        } else {
          this.overlay = false;
          this.tabActive = null;
        }
      }
    },

    menuTopPosition() {
      if(this.windowWidth > 1024) {
        return '0';
      } else {
        return this.headerDOM ? `${this.headerDOM.offsetHeight}px` : '0';
      }
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },

    toggleSubMenuMobile(menu) {
      if (this.windowWidth <= 768) {
        if ((menu && menu.children_categories) || (menu && menu.landing_page)) {
          this.tabActive = menu.name;
        } else {
          this.tabActive = null;
        }
      }
    },

    displayMainMenuMobile() {
      this.tabActive = null;
    },

    addUrlSlash(url) {
      return url.charAt(0) !== "/" ? `/${url}` : url;
    },

    formatUrl(url) {
      let newUrl = url;

      switch (true) {
        case url.includes("{{baseSecureUrl}}"):
          return (newUrl = url.replace("{{baseSecureUrl}}", `${this.baseUrl}/`));
        case url.includes("{{baseUrl}}"):
          return (newUrl = url.replace("{{baseUrl}}", `${this.baseUrl}/`));
        case url.startsWith('http'):
          return newUrl = url;
        default:
          return (newUrl = this.baseUrl + this.addUrlSlash(url));
      }
    },

    setUrl(menu) {
      return menu.category_url_redirect_menu ?
                this.formatUrl(menu.category_url_redirect_menu) :
                  (menu.soon_category_url_redirect ?
                    this.formatUrl(menu.soon_category_url_redirect) : this.formatUrl(menu.url_path));          
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    if( document.getElementById('Header').classList.contains('catalog-category-view') ){
        this.isObfuscate = true;
    }
    if( document.getElementById('Header').classList.contains('catalog-product-view') ){
        this.isObfuscate = true;
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
